import { Fight } from '../models/fight.model';
import { SeasonFights } from '../models/seasonFights.model';

export const calculateAge = (dob: string): number => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const convertToFeetInches = (cm: number): string => {
  const inches = cm * 0.393701;
  const feet = Math.floor(inches / 12);
  const remainingInches = Math.round(inches % 12);
  return `${feet}'${remainingInches}"`;
};

export const convertToInches = (cm: number): number => {
  return Math.round(cm * 0.393701);
};

export const extractNameParts = (
  fullName: string,
): { firstName: string; lastName: string } => {
  const nameParts = fullName.split(' ');
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(' ');
  return { firstName, lastName };
};

export const calculateTotalPointsForFighter = (
  fighterId: string,
  seasonFights: SeasonFights[],
  allFights: Fight[],
): number => {
  let totalPoints = 0;

  seasonFights.forEach((seasonFight) => {
    if (
      seasonFight.fighter_1_id === fighterId ||
      seasonFight.fighter_2_id === fighterId
    ) {
      const fightDetails = allFights.find(
        (fight) => fight.id === seasonFight.fight_id,
      );
      if (fightDetails) {
        if (seasonFight.fighter_1_id === fighterId) {
          totalPoints += fightDetails.fighter_1_points || 0;
        } else if (seasonFight.fighter_2_id === fighterId) {
          totalPoints += fightDetails.fighter_2_points || 0;
        }
      }
    }
  });

  return totalPoints;
};
